export class FilterResponseModel {
    public currentPage: number;
    public pageCount: number;
    public pageSize: number;
    public totalRecords: number;
    public totalRecordsFiletered: number;
    public resultSet: Array<any>;
}



// WEBPACK FOOTER //
// ./src/models/filter.response.model.ts